import { render } from "./ContactsN.vue?vue&type=template&id=5f792e99"
import script from "./ContactsN.vue?vue&type=script&lang=js"
export * from "./ContactsN.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pixsmart_site_v2\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__